import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import dayjs from 'dayjs';

export class DateTimeValidators {
    static dateTimeValid<T>(dateFormControlName: keyof T, timeFormControlName: keyof T): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const dateFormControl = formGroup.get(dateFormControlName as string);
            const timeFormControl = formGroup.get(timeFormControlName as string);
            const dateWithTime = getDateTime(dateFormControl.value, timeFormControl.value);
            const now = dayjs();
            if (!dateWithTime || !dateWithTime.isValid()) {
                return null;
            }
            delete dateFormControl.errors?.dateInFuture;
            delete timeFormControl.errors?.timeInFuture;

            if (dateWithTime.isAfter(now)) {
                dateFormControl.setErrors({...dateFormControl.errors, dateInFuture: true});
                timeFormControl.setErrors({...timeFormControl.errors, timeInFuture: true});
                dateFormControl.markAsTouched();
                timeFormControl.markAsTouched();
            } else {
                dateFormControl.updateValueAndValidity({onlySelf: true});
                timeFormControl.updateValueAndValidity({onlySelf: true});
            }
            return null;
        };
    }

    static rangeValid<T>(
        minDateFormControlName: keyof T,
        minTimeFormControlName: keyof T,
        maxDateFormControlName: keyof T,
        maxTimeFormControlName: keyof T,
    ): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const startDateControl = formGroup.get(minDateFormControlName as string);
            const startTimeControl = formGroup.get(minTimeFormControlName as string);
            const endDateControl = formGroup.get(maxDateFormControlName as string);
            const endTimeControl = formGroup.get(maxTimeFormControlName as string);
            const startDate = getDateTime(startDateControl.value, startTimeControl.value);
            const endDate = getDateTime(endDateControl.value, endTimeControl.value);
            const now = dayjs();
            if (!startDate || !endDate) {
                return null;
            }
            const isInvalidRange = startDate.isValid() && endDate.isValid() && (startDate.isAfter(endDate) || endDate.isAfter(now));
            [startDateControl, endDateControl, startTimeControl, endTimeControl].forEach(control => {
                delete control.errors?.invalidRange;
                if (isInvalidRange) {
                    control.setErrors({...control.errors, invalidRange: true});
                    control.markAsTouched();
                } else {
                    control.updateValueAndValidity({onlySelf: true});
                }
            });
            return null;
        };
    }
}

export function getDateTime(date: string, time: string): dayjs.Dayjs {
    const startDate = dayjs(date);
    let dateWithTime: dayjs.Dayjs;
    if (startDate && time) {
        const timeParts = time.split(':');
        if (timeParts.length > 1) {
            const [hours, minutes] = time.split(':').map(Number);
            dateWithTime = startDate.hour(hours).minute(minutes).second(0).millisecond(0);
        } else {
            return null;
        }
    } else {
        dateWithTime = startDate.hour(0).minute(0).second(0).millisecond(0);
    }
    return dateWithTime;
}
